import { SparkComponent } from "ags/components/ags-spark-component";
import { TrailDisplayComponent } from "ags/components/trail-display";
import { Layers } from "appworks/graphics/layers/layers";
import { Contract } from "appworks/utils/contracts/contract";
import { Timer } from "appworks/utils/timer";
import { Signal } from "signals";
import { AnimateSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import { SymbolSubcomponent } from "slotworks/components/matrix/symbol/symbol-subcomponent";

export class AgsSparkBehaviour extends AnimateSymbolBehaviour {

    public animationComplete: Signal;

    protected trailDisplay: TrailDisplayComponent;
    protected upgradeLevel: number;
    protected sparkComponent: SparkComponent;

    public constructor(symbol: SymbolSubcomponent, upgradeLevel: number, trailDisplay: TrailDisplayComponent) {
        super(symbol);
        this.animationComplete = new Signal();
        this.upgradeLevel = upgradeLevel;
        this.trailDisplay = trailDisplay;
    }

    public land() {

        return new Contract<void>((resolve) => {
            this.animate("_land", ["land"], true).execute();

            // Timer to ensure firework fires at the correct time in the symbol animation.
            Timer.setTimeout(() => {
                const doUpgrade = this.upgradeLevel >= 0;
                this.sparkComponent = this.getSparkComponent();

                this.sparkComponent.fire().then(() => {
                    if (doUpgrade) {
                        this.trailDisplay.upgrade(this.upgradeLevel);
                    }
                    this.trailDisplay.sparkLanded();
                });

                this.sparkComponent.onParticlesGone.addOnce(() => {
                    if (!this.animation) {
                        this.animationComplete.dispatch();
                    } else {
                        this.animation.onComplete.addOnce(() => this.animationComplete.dispatch());
                    }

                    resolve(null);
                });

            }, this.trailDisplay.landDelay + this.delay);
        });
    }

    public destroy() {
        if (this.sparkComponent) {
            this.sparkComponent.destroy();
            this.sparkComponent = null;
        }
    }

    protected getSparkComponent() {
        const position = this.trailDisplay.getPosition();
        return new SparkComponent(this.symbol, position, Layers.get("TrailFireworks"));
    }
}
